var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,on:{"click":_vm.onToPath}},[_c('span',{staticClass:"vi-sidebar-parent-item--icon",class:_vm.item.reIcon ? 'hfs' : 'el-icon-s-promotion',domProps:{"innerHTML":_vm._s(_vm.item.reIcon ? _vm.item.reIcon : '')}}),_vm._v(" "),_c('span',{staticClass:"vi-sidebar-parent-item--text"},[_vm._v(_vm._s(_vm.item.reModule.substr(0,2)))]),_vm._v(" "),_c('span',{staticClass:"vi-sidebar-parent-item--line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/js/module/layout/_source/sidebarParentItem.vue